// libs
import React, { memo } from 'react';

// defs
import { IScrollButtonProps } from './types';

// styles
import { ButtonContainer, ScrollIcon } from './styles';

function ScrollButton({ scrollButtonType, className = '', onClick }: IScrollButtonProps) {
  return (
    <ButtonContainer onClick={onClick} buttonType={scrollButtonType} className={className}>
      <ScrollIcon iconType={scrollButtonType} className="icon-arrow" />
    </ButtonContainer>
  );
}

export default memo(ScrollButton);
